module.exports = __webpack_public_path__ + "static/media/PhoneWrong.f99b022c.svg";